import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { AIAvatarPresentation } from "@/components/sections/AIAvatarPresentation";
import { Helmet } from "react-helmet-async";

const AvatarDemo = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>AI Avatar Demo | BizMatch</title>
        <meta name="description" content="Watch our AI avatar explain how BizMatch works — Australia's premier business marketplace." />
      </Helmet>
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <AIAvatarPresentation />
      </main>
      <Footer />
    </div>
  );
};

export default AvatarDemo;
